// A path-qualified key requests only a rendered tree node's bucket.
export function facetRequest(params, keys) {
    const {all_ids, graph, tag_aggregates_only, date_aggregates_only, download_aggregates_only,
        include_download_aggregates, ...searchParams} = params;
    const facetKeys = [...new Set(keys.map(key => key.split(':')[0]))];
    const paths = {};
    keys.forEach(key => {
        const [field, path] = key.split(':');
        if(path && !keys.includes(field)) (paths[field] ||= []).push(path);
    });
    return {...searchParams, page: 1, per_page: 0, include_totals: true, aggregates_only: true,
        include_selection: false, facet_keys: facetKeys, facet_paths: paths,
        map_clusters: false, map_density: false};
}

export function mergeFacets(previous, incoming, keys) {
    const result = {...previous, ...incoming};
    // A refreshed facet can disappear entirely when its last match is removed.
    keys.filter(key => !key.includes(':') && !(key in incoming)).forEach(key => delete result[key]);
    keys.filter(key => key.includes(':')).forEach(key => {
        const [field, path] = key.split(':');
        if(!(field in incoming) && result[field]?.buckets) {
            result[field] = {...result[field], buckets: result[field].buckets.filter(bucket => bucket.key !== path)};
        }
    });
    Object.entries(incoming).forEach(([field, value]) => {
        if(!keys.includes(field) && keys.some(key => key.startsWith(`${field}:`)) && value.buckets) {
            const buckets = new Map((previous[field]?.buckets || []).map(bucket => [bucket.key, bucket]));
            keys.filter(key => key.startsWith(`${field}:`)).forEach(key => buckets.delete(key.slice(field.length + 1)));
            value.buckets.forEach(bucket => buckets.set(bucket.key, bucket));
            result[field] = {...value, buckets: [...buckets.values()]};
        }
    });
    return result;
}
